import { createContext, useContext, useState, useCallback } from 'react';

const FiltersContext = createContext();
FiltersContext.displayName = 'FiltersContext';

export function FiltersProvider({ children }) {
  const [filters, setFilters] = useState({
    searchTerm: '',
    entityType: '',
    clientId: '0',
  });

  const updateFilters = useCallback((newFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  }, []);

  const value = { filters, updateFilters };

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
}

export function useFilters() {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
}
